import React from "react";
import { Button, Glyphicon } from "react-bootstrap";
import "../css/LoaderButton.css";

export default ({
  isLoading,
  text,
  loadingText,
  className = "",
  disabled = false,
  ...props
}) =>
    <Button
      className={`LoaderButton ${className}`}
      disabled={disabled || isLoading}
      style = {{width: props.width, height: props.height, fontSize: props.fontSize, color: "white", backgroundColor: props.btncolor /*"#fcc208"  "#9f1e32"*/ }}
      {...props}
    >
        {isLoading && <Glyphicon glyph="refresh" className="spinning" />}
        {!isLoading ? text : loadingText}
      </Button>;



// WEBPACK FOOTER //
// ./src/components/LoaderButton.js